import { render } from "./404.vue?vue&type=template&id=6120b242"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/efakturastat.dev.oneit.rs/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/views/404.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6120b242"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6120b242', __exports__)) {
    console.log('reload')
    api.reload('6120b242', __exports__)
  }
  
  module.hot.accept("./404.vue?vue&type=template&id=6120b242", () => {
    console.log('re-render')
    api.rerender('6120b242', render)
  })

}


export default __exports__